import { ReleaseNoteStyles } from 'legoland-sdk/dist/experimental';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommunicationMessage = ({
  communicationItem
}) => /*#__PURE__*/_jsx(ReleaseNoteStyles, {
  as: ReactMarkdown,
  components: {
    h1: 'h3',
    h2: 'h4',
    h3: 'h5',
    h4: 'h6',
    h5: 'h6'
  },
  rehypePlugins: [rehypeRaw],
  remarkPlugins: [remarkGfm],
  "data-sentry-element": "ReleaseNoteStyles",
  "data-sentry-component": "CommunicationMessage",
  "data-sentry-source-file": "CommunicationMessage.tsx",
  children: communicationItem.message
});